<template>
  <div class="add-owe-fee-callable-container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>{{ $t('addOweFeeCallable.title') }}</span>
      </div>

      <el-form label-position="right" label-width="120px" class="text-left">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$t('addOweFeeCallable.callableWay')">
              <el-select v-model="addOweFeeCallableInfo.callableWay" style="width:100%"
                :placeholder="$t('addOweFeeCallable.selectCallableWay')">
                <el-option v-for="item in callableWayOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$t('addOweFeeCallable.feeConfigs')">
              <!-- 费用全选框，参照欠费房屋全选写法  create by cht at 2026/6/27 11:20 -->
              <el-checkbox v-model="checkAllFeeStatus" @change="handleCheckAllFeeChange">
                全选
              </el-checkbox>
              <el-checkbox-group v-model="addOweFeeCallableInfo.configIds" @change="loadOweFeeRooms">
                <el-checkbox v-for="item in addOweFeeCallableInfo.feeConfigs" :key="item.configId"
                  :label="item.configId">
                  {{ item.feeName }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$t('addOweFeeCallable.floor')">
              <el-select v-model="addOweFeeCallableInfo.floorId" style="width:100%" @change="handleFloorChange"
                :placeholder="$t('addOweFeeCallable.selectFloor')">
                <el-option v-for="item in addOweFeeCallableInfo.floors" :key="item.floorId" :label="item.floorNum"
                  :value="item.floorId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$t('addOweFeeCallable.unit')">
              <el-select v-model="addOweFeeCallableInfo.unitId" style="width:100%" @change="loadOweFeeRooms"
                         :placeholder="$t('addOweFeeCallable.selectUnit')">
                <el-option v-for="item in addOweFeeCallableInfo.units" :key="item.unitId" :label="item.unitNum"
                           :value="item.unitId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$t('addOweFeeCallable.timeRange')">
              <el-select v-model="addOweFeeCallableInfo.hasTime" style="width:100%" @change="loadOweFeeRooms"
                :placeholder="$t('addOweFeeCallable.selectTimeRange')">
                <el-option v-for="item in timeRangeOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" v-show="addOweFeeCallableInfo.hasTime === 'ON'">
          <el-col :span="12">
            <el-form-item :label="$t('addOweFeeCallable.startTime')">
              <el-date-picker v-model="addOweFeeCallableInfo.startTime" type="datetime" style="width:100%" value-format="yyyy-MM-dd HH:mm:ss"                :placeholder="$t('addOweFeeCallable.selectStartTime')" >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('addOweFeeCallable.endTime')">
              <el-date-picker v-model="addOweFeeCallableInfo.endTime" type="datetime" style="width:100%" value-format="yyyy-MM-dd HH:mm:ss"                :placeholder="$t('addOweFeeCallable.selectEndTime')" >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$t('addOweFeeCallable.oweRooms')">
              <div v-if="addOweFeeCallableInfo.rooms && addOweFeeCallableInfo.rooms.length > 0">
<!--                <el-checkbox v-model="checkAllStatus" @change="handleCheckAllChange">-->
<!--                  {{ $t('addOweFeeCallable.checkAll') }}-->
<!--                </el-checkbox>-->
                <!-- 超过最大限度时,分批次导出 create by cht at 2026/7/2 -->
                <div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;margin-bottom:10px;">
                  <el-checkbox v-if="addOweFeeCallableInfo.rooms.length <= MAX_EXPORT_LIMIT" v-model="checkAllStatus" @change="handleCheckAllChange">
                    {{ $t('addOweFeeCallable.checkAll') }}
                  </el-checkbox>
                  <!-- 仅房屋总数超过140才展示分批按钮 -->
                  <template v-if="addOweFeeCallableInfo.rooms.length > MAX_EXPORT_LIMIT">
                    <template v-for="(item, idx) in batchList">
                      <el-button size="mini" @click="switchBatch(idx)" :key="idx">
                        第{{idx+1}}批 {{item.start+1}}~{{item.end}}户
                      </el-button>
                    </template>
                  </template>
                  <span v-if="addOweFeeCallableInfo.rooms.length > MAX_EXPORT_LIMIT" style="color:#f56c6c;font-size:12px;">单次导出最多{{MAX_EXPORT_LIMIT}}户，请分批导出</span>
                </div>
                <!-- create by cht at 2026/7/2 -->
                <el-checkbox-group v-model="addOweFeeCallableInfo.roomIds" @change="handleCheckedRoomsChange">
                  <el-checkbox v-for="item in addOweFeeCallableInfo.rooms" :key="item.payerObjId"
                    :label="item.payerObjId">
                    {{ item.payerObjName }}
                  </el-checkbox>
                </el-checkbox-group>
<!--                <el-button @click="batchCheckRoom" type="text">测试批量勾选</el-button>-->
              </div>
              <div v-else>
                {{ $t('addOweFeeCallable.noOweRooms') }}
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24" class="text-right">
            <el-button @click="goBack">{{ $t('common.back') }}</el-button>
            <el-button v-if="addOweFeeCallableInfo.callableWay === 'EXCEL'" type="primary"
              @click="exportCollectionLetterExcel">
              {{ $t('common.export') }}
            </el-button>
<!--            <el-button v-else-if="addOweFeeCallableInfo.callableWay === 'TTS'" type="primary" @click="ttsOweFee">-->
<!--              {{ $t('addOweFeeCallable.ttsCall') }}-->
<!--            </el-button>-->
            <el-button v-else type="primary" @click="saveOweFeeCallable">
              {{ $t('common.submit') }}
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import {
  saveOweFeeCallable,
  exportCollectionLetterExcel,
  listFeeConfigs,
  queryFloors,
  queryUnits,
  queryReportOweFee
} from '@/api/fee/addOweFeeCallableApi'

export default {
  name: 'AddOweFeeCallableList',
  data() {
    return {
      // 新增这两行 create by cht at 2026/7/2 17:30
      MAX_EXPORT_LIMIT: 140,
      batchList: [], // 新增
      addOweFeeCallableInfo: {
        callableWay: '',
        remark: '',
        floorId: '',
        unitId:'',
        communityId: '',
        configIds: [],
        roomId: '',
        roomIds: [],
        rooms: [],
        feeConfigs: [],
        hasTime: 'OFF',
        startTime: '',
        endTime: '',
        floors: [],
        units: [],
      },
      callableWayOptions: [
        { value: 'WECHAT', label: '微信模板消息' },
        { value: 'SMS', label: '短信' },
        { value: 'EXCEL', label: '导出' }
        // { value: 'TTS', label: '呼电话催缴' }
      ],
      timeRangeOptions: [
        { value: 'OFF', label: '否' },
        { value: 'ON', label: '是' }
      ],
      checkAllStatus: false,
      checkAllFeeStatus: false, // 新增:催缴费用全选状态 create by cht at 2026/6/27 11:20
      loading: false
    }
  },
  created() {
    this.addOweFeeCallableInfo.communityId = getCommunityId()
    this.listFeeConfigs()
    this.loadOweFeeFloors()
    this.loadOweFeeUnits()   //create by cht at 2026/7/2 10:05

  },
  methods: {
    async listFeeConfigs() {
      try {
        const params = {
          page: 1,
          row: 100,
          communityId: this.addOweFeeCallableInfo.communityId,
          isDefault: 'F'
        }
        const { feeConfigs } = await listFeeConfigs(params)
        this.addOweFeeCallableInfo.feeConfigs = feeConfigs
      } catch (error) {
        console.error('获取费用配置失败:', error)
      }
    },
    async loadOweFeeFloors() {
      try {
        const params = {
          page: 1,
          row: 100,
          communityId: this.addOweFeeCallableInfo.communityId
        }
        const { apiFloorDataVoList } = await queryFloors(params)
        this.addOweFeeCallableInfo.floors = apiFloorDataVoList
      } catch (error) {
        console.error('获取楼栋失败:', error)
      }
    },
    /*=======================create by cht at 2026/7/2 10:05===========================*/
    // 楼栋切换事件
    handleFloorChange() {
      // 清空已选单元
      this.addOweFeeCallableInfo.unitId = ''
      // 加载当前楼栋下所有单元
      this.loadOweFeeUnits()
      // 重新查询欠费房屋
      this.loadOweFeeRooms()
    },
    async loadOweFeeUnits() {
      console.log("进入单元加载方法")
      if (!this.addOweFeeCallableInfo.floorId) {
        this.addOweFeeCallableInfo.units = []
        return
      }

      try {
        const params = {
          page: 1,
          row: 500,
          communityId: this.addOweFeeCallableInfo.communityId,
          floorId: this.addOweFeeCallableInfo.floorId
        }
        const res = await queryUnits(params)
        this.addOweFeeCallableInfo.units = res
      } catch (error) {
        console.error('获取欠费单元失败:', error)
      }
    },
    // 自动计算分批区间
    computeBatch() {
      const total = this.addOweFeeCallableInfo.rooms.length
      const arr = []
      const totalBatch = Math.ceil(total / this.MAX_EXPORT_LIMIT)
      for(let i = 0; i < totalBatch; i++) {
        const start = i * this.MAX_EXPORT_LIMIT
        const end = Math.min(start + this.MAX_EXPORT_LIMIT, total)
        arr.push({ start, end })
      }
      this.batchList = arr
    },
    // 切换批次勾选
    switchBatch(batchIndex) {
      const allIdList = this.addOweFeeCallableInfo.rooms.map(item => item.payerObjId)
      const targetBatch = this.batchList[batchIndex]
      const batchIds = allIdList.slice(targetBatch.start, targetBatch.end)
      if(batchIds.length === 0) {
        this.$message.info('该批次无房屋数据')
        return
      }
      this.addOweFeeCallableInfo.roomIds = batchIds
      this.checkAllStatus = batchIds.length === this.addOweFeeCallableInfo.rooms.length
      this.$message.success(`已选中第${batchIndex+1}批，共${batchIds.length}户，可直接导出`)
    },
    /*=======================⬆️create by cht at 2026/7/2 10:05 and 2026/7/2 17:30===========================*/
    async loadOweFeeRooms() {
      if (!this.addOweFeeCallableInfo.floorId ||
        !this.addOweFeeCallableInfo.configIds ||
        this.addOweFeeCallableInfo.configIds.length === 0) {
        return
      }

      try {
        const params = {
          page: 1,
          row: 500,
          configIds: this.addOweFeeCallableInfo.configIds.join(','),
          communityId: this.addOweFeeCallableInfo.communityId,
          floorId: this.addOweFeeCallableInfo.floorId,
          unitId: this.addOweFeeCallableInfo.unitId || ''     //create by cht at 2026/7/2 10:05
        }
        const { data } = await queryReportOweFee(params)
        this.addOweFeeCallableInfo.rooms = data || []
        // 新增一行，自动计算分批  create by cht at 2026/7/2 18:00
        this.computeBatch()
        this.addOweFeeCallableInfo.roomIds = this.addOweFeeCallableInfo.rooms.map(item => item.payerObjId)
        // this.checkAllStatus = this.addOweFeeCallableInfo.rooms.length > 0
        // 总数≤上限：全部勾选才打勾；总数>上限：默认不勾选  create by cht at 2026/7/2 18:00
        const total = this.addOweFeeCallableInfo.rooms.length
        if (total <= this.MAX_EXPORT_LIMIT) {
          this.addOweFeeCallableInfo.roomIds = this.addOweFeeCallableInfo.rooms.map(item => item.payerObjId)
          this.checkAllStatus = true
        } else {
          this.addOweFeeCallableInfo.roomIds = []
          this.checkAllStatus = false
        }
      } catch (error) {
        console.error('获取欠费房屋失败:', error)
      }
    },
    handleCheckAllChange(val) {
      this.addOweFeeCallableInfo.roomIds = val ?
        this.addOweFeeCallableInfo.rooms.map(item => item.payerObjId) : []
    },
    handleCheckedRoomsChange(value) {
      const checkedCount = value.length
      const MAX_LIMIT = this.MAX_EXPORT_LIMIT
      // 超出限制拦截
      if (checkedCount > MAX_LIMIT) {
        this.$message.error(`当前已选中${checkedCount}户房屋，单次导出最多仅支持${MAX_LIMIT}户，请删减勾选后再操作！`)
        // 只保留前140条勾选
        this.addOweFeeCallableInfo.roomIds = value.slice(0, MAX_LIMIT)
        // 同步更新全选框状态
        const newCheckedList = this.addOweFeeCallableInfo.roomIds
        this.checkAllStatus = newCheckedList.length === this.addOweFeeCallableInfo.rooms.length
        return
      }
      this.checkAllStatus = checkedCount === this.addOweFeeCallableInfo.rooms.length
    },
    // batchCheckRoom() { //create by cht at 2026/7/2 15:50
    //   // 修改数字控制勾选条数，测试临界值
    //   const testNum = 149
    //   const allIds = this.addOweFeeCallableInfo.rooms.map(item => item.payerObjId)
    //   // 截取前testNum条赋值
    //   this.addOweFeeCallableInfo.roomIds = allIds.slice(0, testNum)
    //   this.$message.success(`已自动勾选前${testNum}户`)
    // },
    /*===================create by cht at 2026/6/27 11:20========================*/
    // 费用全选切换事件（对应handleCheckAllChange）
    handleCheckAllFeeChange(val) {
      if (val) {
        // 全部勾选：取所有费用configId
        this.addOweFeeCallableInfo.configIds = this.addOweFeeCallableInfo.feeConfigs.map(item => item.configId)
      } else {
        // 清空所有勾选
        this.addOweFeeCallableInfo.configIds = []
      }
      // 勾选变更后自动刷新欠费房屋（原有逻辑保留）
      this.loadOweFeeRooms()
    },
// 单个费用勾选变更时，自动同步全选框状态（对应handleCheckedRoomsChange）
    handleCheckedFeeChange() {
      const checkedCount = this.addOweFeeCallableInfo.configIds.length
      // 勾选数量 == 总费用数量 → 全选框打勾，否则取消
      this.checkAllFeeStatus = checkedCount === this.addOweFeeCallableInfo.feeConfigs.length
    },
    /*=====================create by cht at 2026/6/27 11:20======================*/
    validateForm() {
      if (!this.addOweFeeCallableInfo.callableWay) {
        this.$message.error(this.$t('addOweFeeCallable.callableWayRequired'))
        return false
      }
      if (!this.addOweFeeCallableInfo.roomIds || this.addOweFeeCallableInfo.roomIds.length === 0) {
        this.$message.error(this.$t('addOweFeeCallable.roomsRequired'))
        return false
      }
      return true
    },
    async saveOweFeeCallable() {
      if (!this.validateForm()) return

      try {
        await saveOweFeeCallable(this.addOweFeeCallableInfo)
        this.$message.success(this.$t('common.operationSuccess'))
        this.goBack()
      } catch (error) {
        console.error('提交失败:', error)
        this.$message.error(error.message || this.$t('common.submitFailed'))
      }
    },
    async exportCollectionLetterExcel() {
      if (!this.validateForm()) return

      try {
        const params = {
          communityId: this.addOweFeeCallableInfo.communityId,
          pagePath: 'dataFeeManualCollection',
          configIds: this.addOweFeeCallableInfo.configIds.join(','),
          roomIds: this.addOweFeeCallableInfo.roomIds.join(','),
          startTime: this.addOweFeeCallableInfo.startTime,
          endTime: this.addOweFeeCallableInfo.endTime
        }
        await exportCollectionLetterExcel(params)
        this.$message.success(this.$t('common.operationSuccess'))
        this.$router.push('/pages/property/downloadTempFile?tab=下载中心')
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error(error.message || this.$t('common.exportFailed'))
      }
    },
    // ttsOweFee() {
    //   if (!this.validateForm()) return
    //
    //   const oweFee = this.addOweFeeCallableInfo.rooms
    //     .filter(room => this.addOweFeeCallableInfo.roomIds.includes(room.payerObjId))
    //     .map(room => ({ ...room, state: 'W' }))
    //
    //   if (oweFee.length === 0) {
    //     this.$message.error(this.$t('addOweFeeCallable.noOweRoomsSelected'))
    //     return
    //   }
    //
    //   const data = {
    //     configIds: this.addOweFeeCallableInfo.configIds,
    //     oweFee,
    //     startTime: this.addOweFeeCallableInfo.startTime,
    //     endTime: this.addOweFeeCallableInfo.endTime
    //   }
    //
    //   localStorage.setItem('TTS_OWE_FEE_DATA', JSON.stringify(data))
    //   this.$router.push('/fee/ttsOweFeeCallable')
    // },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.add-owe-fee-callable-container {
  padding: 20px;

  .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
  }

  .el-checkbox {
    margin-right: 0;
  }

  .text-right {
    text-align: right;
  }
}
</style>
